import Request from "./Request";
import config from "./config";

const apiRequest = new Request(
  () => {},
  () => {},
  () => {},
);

export const uploadFileRequest = (params, url, config = {}) => {
  return apiRequest.post(`${url}`, params, config);
};

export const getPaymentModes = () => {
  return apiRequest.get(`${config.apis.admin.PAYMENT_MODE_LIST}`, {});
};

export const getPaymentSettingPreviewRequest = (roleName) => {
  return apiRequest.get(`${config.apis.admin.PAYMENT_SETTING_LIST}?roleName=${roleName}`, {});
};
export const getPaymentSettingListRequest = () => {
  return apiRequest.get(`${config.apis.admin.PAYMENT_SETTING_LIST_ROLE}`, {});
};

export const getManageCardListRequest = (pageNo, pageSize, payload) => {
  return apiRequest.post(`${config.apis.admin.MANAGE_CARD_LIST}?pageNo=${pageNo}&pageSize=${pageSize}`, payload);
};

export const manageCardActionsRequest = (actionType, cardId = "2d28ec4c-803d-433c-b5be-04b28a846144") => {
  const apiUrl = {
    Lock: `${config.apis.admin.MANAGE_CARD_LOCK}/${cardId}`,
    unlock: `${config.apis.admin.MANAGE_CARD_UNLOCK}/${cardId}`,
    block: `${config.apis.admin.MANAGE_CARD_BLOCK}/${cardId}`,
  };
  return apiRequest.post(apiUrl[actionType], {});
};

export const postManageCardReplaceRequest = (params = {}) => {
  return apiRequest.post(`${config.apis.admin.MANAGE_CARD_REPLACE}`, params);
};

export const postAdminConfigurationRequest = (params) => {
  return apiRequest.post(`${config.apis.admin.ADD_ADMIN_CONFIGURATION}`, params);
};

export const getPaymentListing = (params) => {
  return apiRequest.post(`${config.apis.admin.GET_PAYMENT_LISTS}`, params);
};
export const getSettlementListing = (params = {}) => {
  return apiRequest.post(`${config.apis.admin.GET_SETTLEMENT_LISTS}`, params);
};

//
export const getRefundListing = (pageNo, pageSize, params = {}) => {
  return apiRequest.get(`${config.apis.admin.GET_REFUND_LISTS}`);
};

export const getConfigurationInfoConfigLog = (payload) => {
  return apiRequest.post(`${config.apis.admin.GET_CONFIGURATION_INFO_CONFIG_LOG}`, payload);
};

export const getConfigurationInfoLimitLog = (payload) => {
  return apiRequest.post(`${config.apis.admin.GET_CONFIGURATION_INFO_LIMIT_LOG}`, payload);
};

export const getConfigurationInfoFeeLog = (payload) => {
  return apiRequest.post(`${config.apis.admin.GET_CONFIGURATION_INFO_FEE_LOG}`, payload);
};

export const getConfigurationInfoPgLog = (payload) => {
  return apiRequest.post(`${config.apis.admin.GET_CONFIGURATION_INFO_PG_LOG}`, payload);
};
export const getCardConfigInfoLog = (payload) => {
  return apiRequest.post(`${config.apis.admin.GET_PREPAID_CARD_INFO_LOG}`, payload);
};

export const vaRetryCreationRequest = (payload) => {
  return apiRequest.post(`${config.apis.admin.RETRY_VA_ACCOUNT}`, payload);
};

export const getbalanceRequest = () => {
  return apiRequest.get(`${config.apis.admin.GET_BALANCE}`, {});
};

export const vpaRetryCreationRequest = (userId) => {
  return apiRequest.get(`${config.apis.admin.RETRY_VPA_ACCOUNT}/${userId}`);
};

export const getMerchantListing = (params) => {
  return apiRequest.post(`${config.apis.admin.GET_MERCHANT_LISTS}`, params);
};
export const getDashboardDetail = (params) => {
  return apiRequest.post(`${config.apis.admin.DASHBOARD_DETAILS}`, params);
};
export const getTransactionDetail = (params) => {
  return apiRequest.post(`${config.apis.admin.TRANSACTION_GRAPH}`, params);
};
export const getUserProfileDetaile = () => {
  return apiRequest.get(`${config.apis.user.GET_PROFILE}`);
};
export const getBalence = (userId) => {
  return apiRequest.get(`${config.apis.admin.BALANCE_INFORMANTION}/${userId}`);
};
export const fetchPermissionsRequest = (pageNo, pageSize, nameFilter, descriptionFilter) => {
  return apiRequest.post(
    // `${config.API_BASEPATH_STAGING}/user-service/admin/permission/v1/get-all`, // Direct URL if not in config
    `${config.apis.accessManagement.GET_ALL_PERMISSIONS}`, // Assuming you add this to your config
    {
      name: nameFilter,
      description: descriptionFilter,
      pageSize: pageSize, // API expects string for pageSize
      pageNo: pageNo,
    },
  );
};
export const createPermissionRequest = (permission) => {
  // Similarly, for create, edit, toggleStatus, ensure these are in your config.
  // Add: `CREATE_PERMISSION: "/user-service/admin/permission/v1/create",`
  return apiRequest.post(`${config.apis.accessManagement.CREATE_PERMISSION}`, {
    name: permission.name,
    description: permission.description,
  });
};

export const editPermissionRequest = (permissionName, newDescription) => {
  // Add: `EDIT_PERMISSION: "/user-service/admin/permission/v1/edit",`
  return apiRequest.put(`${config.apis.accessManagement.EDIT_PERMISSION}`, {
    permissionName: permissionName,
    description: newDescription,
  });
};

export const togglePermissionStatusRequest = (permissionName, newStatus) => {
  // Add: `TOGGLE_PERMISSION_STATUS: "/user-service/admin/permission/v1",`
  // This one is a bit tricky with the URL structure, if it's dynamic like /v1/{name}/status
  // The `Request` class should be able to handle dynamic parts in the URL.
  return apiRequest.put(`${config.apis.accessManagement.TOGGLE_PERMISSION_STATUS_BASE}/${permissionName}/status`, {
    status: newStatus,
  });
};

// API to get all roles with pagination and filters
export const fetchRolesRequest = async (currentPage = 0, itemsPerPage, roleNameFilter, descriptionFilter) => {
  const params = {
    pageNo: currentPage,
    pageSize: itemsPerPage,
    roleName: roleNameFilter,
    description: descriptionFilter,
  };
  return await apiRequest.post(`${config.apis.accessManagement.GET_ALL_ROLES}`, { ...params });
};

// API to create a new role
export const createRoleRequest = async (roleData) => {
  return await apiRequest.post(`${config.apis.accessManagement.CREATE_ROLES}`, roleData);
};

// API to edit a role (description only for now)
export const editRoleRequest = async (roleName, description) => {
  const data = { roleName, description };
  return await apiRequest.put(`${config.apis.accessManagement.EDIT_ROLE}`, data);
};

// API to get a single role's data and all available permissions
export const fetchRolePermissionsRequest = async (roleName) => {
  // Construct the URL by appending the roleName to the base path
  const url = `${config.apis.accessManagement.ROLE_DATA_WITH_PERMISSION}/${roleName}`;

  // Use the standard GET function without a data payload
  return await apiRequest.get(url);
};

// API to update a role's permissions
export const updateRolePermissionsRequest = async (roleName, addPermissions, removePermissions) => {
  const data = { roleName, addPermissions, removePermissions };
  return await apiRequest.put(`${config.apis.accessManagement.ADD_REMOVE_PERMISSION_TO_ROLE}`, data);
};

export const getRoleDropdowns = async () => {
  return await apiRequest.get(`${config.apis.accessManagement.GET_DROPDOWN_DETAILS}`);
};

export const getSocieties = async (payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.GET_ALL_SOCIETIES}`, payload);
};

export const societyUserList = async (data) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.ALL_USERS}`, data);
};

export const getSettlementTransactions = async (payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.SETTLEMENT_LIST}`, payload);
};

export const getUserTransactions = async (payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.USER_TRANSACTIONS}`, payload);
};

export const getMainWalletBalance = async (userId) => {
  return await apiRequest.get(
    `${config.apis.societyPartnerHub.MAIN_WALLET_BALANCE}?userId=${userId}`
  );
};

export const getBalancePrefunded = async (payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.BALANCE}`, payload);
};

export const perSettlementTransactions = async (payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.PER_SETTLEMENT_TXN}`, payload);
};

export const getOrgWalletLedger = async (payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.LEDGER_LIST}`, payload);
};

export const getAccDetails = async (payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.ACC_DETAILS}`, payload);
};

export const getLedgerDetails = async (txnId, payload) => {
  return await apiRequest.post(`${config.apis.societyPartnerHub.LEDGER_DETAILS}/${txnId}`, payload);
};
export const addCardProductRequest = (payload) => {
  return apiRequest.post(`${config.apis.cardManagement.ADD_CARD_PRODUCT}`, payload);
};
export const listCardProductsRequest = (payload) => {
  return apiRequest.post(`${config.apis.cardManagement.LIST_CARD_PRODUCTS}`, payload);
};
export const markCardProductDefaultRequest = (payload) => {
  return apiRequest.post(`${config.apis.cardManagement.MARK_CARD_PRODUCT_DEFAULT}`, payload);
};
export const listOrgCardRequest = (payload) => {
  return apiRequest.post(`${config.apis.cardManagement.LIST_ORG_CARDS}`, payload);
};
export const addOrgCardMapping = (payload) => {
  return apiRequest.post(`${config.apis.cardManagement.ADD_ORG_CARD_MAPPING}`, payload);
};
export const getOrgCardDetails = (payload) => {
  return apiRequest.post(`${config.apis.cardManagement.VIEW_CARD_PRODUCT_DETAILS}`, payload);
};
export const uploadMccCsvRequest = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return apiRequest.upload(config.apis.user.UPLOAD_MCC_CSV, formData);
};
export const getQRRequestList = (payload) => {
  return apiRequest.post(`${config.apis.InventoryManagement.GET_QR_REQUEST_LIST}`, payload);
};
export const createQRRequest = (payload) => {
  const res = apiRequest.post(`${config.apis.InventoryManagement.CREATE_QR_REQUEST}`, payload);
  console.log("response from create QR request", res);
  return res;
};
export const getInventoryList = (payload) => {
  return apiRequest.post(`${config.apis.InventoryManagement.GET_INVENTORY_LIST}`, payload);
};

export const getMerchantListingMob = (payload) => {
  return apiRequest.post(`${config.apis.admin.MERCHANT_LIST}`, payload);
};
export const allotVpaByAdmin = (vpa, userId) => {
  // POST to the endpoint using query params like your curl; adjust path in config if available
  const url = `${config.apis.InventoryManagement.VPA_ALLOTMENT}?vpa=${vpa}&userId=${userId}`;
  return apiRequest.post(url, {}); // send empty body as per your curl
};

export const uploadSoundboxInventory = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return apiRequest.upload(config.apis.InventoryManagement.UPLOAD_SOUNDBOX_INVENTORY, formData);
};

export const soundboxInventoryList = (payload) => {
  return apiRequest.post(`${config.apis.InventoryManagement.SOUNDBOX_INVENTORY_LIST}`, payload);
};
export const deallocateSoundboxRequest = (userId) => {
  console.log("Deallocating soundbox for userId:", userId);
  return apiRequest.put(`${config.apis.InventoryManagement.DEALLOCATE_SOUNDBOX}?userId=${userId}`, {});
};
export const getAssignedUserDetailsRequest = (payload) => {
  return apiRequest.post(`${config.apis.InventoryManagement.SOUNDBOX_ASSIGNED_LIST}`, payload);
};

export const allocateSoundboxRequest = (payload) => {
  return apiRequest.post(`${config.apis.InventoryManagement.ALLOCATE_SOUNDBOX}`, payload);
};
export const getPartnerDashboardSummary = (orgUserId) => {
  return apiRequest.get(`${config.apis.societyPartnerHub.PARTNER_DASHBOARD_SUMMARY}?orgUserId=${orgUserId}`, {});
};
